module.exports = __webpack_public_path__ + "static/media/tanqueMSPTN.e61022ee.jpg";